import { Space, Tabs } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CustomTabs from "../Tabs";
import { useLocation, useNavigate } from "react-router-dom";

interface TabsRenderProps {
    selectedKey?: string;
    selectedMenu?: any;
}

interface ItemRecord {
    status?: string;
    _id?: string;
    name: string;
    parentMenu?: string;
    createdAt?: string;
    updatedAt?: string;
    subparentMenu?: string;
    routeUrl?: string;
    componentName?: string;
    icon?: string;
    order: number;
    subMenu?: string;
    mainMenuRef?: any;
    subMenuRef?: any;
    parentMenuRef?: any;
    newTab?: any;
    menuId?: string;
    parentId?: string;
    list?: ItemRecord[];
    isNew?: boolean;
}

const TabsRender: React.FC<TabsRenderProps> = ({
    selectedMenu
}) => {
    const { tabs } = useSelector((state: any) => ({
        tabs: state.app.tabs,
    }));
    const [selectedTab, setSelectedTab] = React.useState<ItemRecord | null>(null);
    const [tabList, setTabList] = React.useState<ItemRecord[]>([]);

    const navigate = useNavigate();

    const sort = (a, b) => a.order - b.order;

    useEffect(() => {
        setTabList(tabs.filter(item => item.menuId === selectedMenu).sort(sort) || [])
    }, [selectedMenu]);

    const findParentTabs = (itemId: string): ItemRecord[] => {
        const parents: ItemRecord[] = [];
        let currentItem = tabList.find(item => item._id === itemId);
        while (currentItem && currentItem.parentId) {
            currentItem = tabList.find(item => item._id === currentItem.parentId);
            if (currentItem) {
                parents.unshift(currentItem);
            }
        }
        return parents;
    };

    const handleTabChange = (activeKey: string) => {
        const activeTab = tabList.find(item => item._id === activeKey);
        setSelectedTab(activeTab || null);
        if (!tabList.find(item => item.parentId === activeKey)) {
            if (activeTab?.routeUrl) {
                navigate('/' + activeTab?.routeUrl);
            } else {
                navigate('');
            }
        }
        console.log("activeKey", activeKey);
    }

    const renderTabs = (parrentId = undefined) => {
        const itemsToRender = tabList.filter(item => item.parentId === parrentId).map(item => ({ ...item, key: item._id, label: item.name, content: null }));
        return <CustomTabs
            tabs={itemsToRender}
            defaultActiveKey={itemsToRender[0]?.key}
            onTabChange={handleTabChange}
        />
    }

    const renderHierarchy = (selectedItem: ItemRecord | null) => {
        if (!selectedItem) {
            return null;
        }
        const parentTabs = findParentTabs(selectedItem._id);
        const childItems = tabList.filter(item => item.parentId === selectedItem._id);

        return (
            <Space direction="vertical" style={{ width: '100%' }}>
                {parentTabs.map((parentTab) => (
                    <div key={parentTab._id}>
                        {renderTabs(parentTab._id)}
                    </div>
                ))}
                {childItems.length > 0 ? renderTabs(selectedItem._id) : null}
            </Space>
        );
    };

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            {renderTabs(undefined)}
            {renderHierarchy(selectedTab)}
        </Space>
    );
}

export default TabsRender;